import React, { useState } from 'react';
import MaxBoxes from './MaxBoxes';

const Homes = () => {
    const [numRows, setNumRows] = useState('');
    const [numColumns, setNumColumns] = useState('');
    const [numColors, setNumColors] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const handleRows = (e) => {
        if (e.target.value > 40) {
            alert("Your input value must not be greater than 40!");
        }
        else {
            setNumRows(e.target.value);
            setSubmitted(false);
            setShowAlert(false);
        }
    }
    const handleColumns = (e) => {
        if (e.target.value > 40) {
            alert("Your input value must not be greater than 40!");
        }
        else {
            setNumColumns(e.target.value);
            setSubmitted(false);
            setShowAlert(false);
        }
    }
    const handleColors = (e) => {
        if (e.target.value > 20) {
            alert("Your input value must not be greater than 20!");
        }
        else {
            setNumColors(e.target.value);
            setSubmitted(false);
            setShowAlert(false);
        }
    }

    const handleSubmit = () => {
        if (numRows && numColumns && numColors) {
            setSubmitted(true);
            // console.log('Button clicked');
        } else {
            setShowAlert(true);
        }

    }

    return (
        <div  className='container'>
            <div>
                <h1 className='text-center my-4'>Colored box generator.</h1>
                <div className="mb-3">
                    {/* <label htmlFor="formGroupExampleInput" className="form-label">Number of cell on the width</label> */}
                    <input type="text" className="form-control" id="formGroupExampleInput" placeholder="Enter the number of cell for height" value={numRows} onChange={handleRows} required />
                </div>
                <div className="mb-3">
                    {/* <label htmlFor="formGroupExampleInput2" className="form-label">Number of cell on the height</label> */}
                    <input type="text" className="form-control" id="formGroupExampleInput2" placeholder="Enter the number of cell for width" value={numColumns} onChange={handleColumns} required />
                </div>
                <div className="mb-3">
                    {/* <label htmlFor="formGroupExampleInput2" className="form-label">Number of colors</label> */}
                    <input type="text" className="form-control" id="formGroupExampleInput2" placeholder="Enter the maximum required colors" value={numColors} onChange={handleColors} required />
                </div>
                <div className="mb-3">
                    <button type="submit" className="btn btn-primary" onClick={() => handleSubmit()} disabled={!numRows && !numColumns && !numColors}>Submit</button>
                </div>
            </div>

            <div className="container">
                {showAlert && (
                    <div className="alert alert-danger" role="alert">
                        Please fill all the input field.
                    </div>
                )}
            </div>

            <br />
            {
                submitted ? (
                    <MaxBoxes numRows={numRows} numColumns={numColumns} numColors={numColors} />
                ) : (
                    <><h2 style={{backgroundColor:'cyan', textAlign:'center', paddingTop:'2rem', paddingBottom:'2rem'}}>Please fill the above data to see the boxes here!</h2></>
                )
            }
        </div>
    );
};

export default Homes;